import React, { useEffect, useState } from "react";
import { Table, Button, Pagination } from "rsuite";

import "../../styles/Master.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";

const { Column, HeaderCell, Cell } = Table;

function VetTable({ referenceNumber }) {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };

  const finalData = data.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  async function getInfo() {
    const result = await axiosInstance.post("/api/get-vet-treatments-ref", {
      reference_number: referenceNumber,
    });
    const numbers = result.data;
    setData(numbers);
  }

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div className="master-display-table">
      <Table
        virtualized
        height={300}
        data={finalData}
        autoHeight={true}
        affixHeader
        affixHorizontalScrollbar
        rowHeight={50}
        headerHeight={30}
        onRowClick={(rowData) => {}}
      >
        <Column width={130} align="center" fixed>
          <HeaderCell>Reference Number</HeaderCell>
          <Cell dataKey="reference_number" />
        </Column>
        <Column width={130} resizable>
          <HeaderCell>Date</HeaderCell>
          <Cell dataKey="date" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Vet Name/Facility</HeaderCell>
          <Cell dataKey="vet_facility" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Reason</HeaderCell>
          <Cell dataKey="reason" />
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Medication</HeaderCell>
          <Cell dataKey="medication" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Medication Reason</HeaderCell>
          <Cell dataKey="medication_reason" />
        </Column>

        <Column width={80} resizable>
          <HeaderCell>Anaethesia</HeaderCell>
          <Cell dataKey="anaethesia" />
        </Column>

        <Column width={80} resizable>
          <HeaderCell>Glucose Reading</HeaderCell>
          <Cell dataKey="glucose_reading" />
        </Column>
        <Column width={80} resizable>
          <HeaderCell>Body Temperature</HeaderCell>
          <Cell dataKey="body_temp" />
        </Column>
        <Column width={50} resizable>
          <HeaderCell>Drug Administered</HeaderCell>
          <Cell dataKey="drug_administered" />
        </Column>
        <Column width={80} resizable>
          <HeaderCell>Volume</HeaderCell>
          <Cell dataKey="volume" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Method</HeaderCell>
          <Cell dataKey="method" />
        </Column>
        <Column width={300} resizable>
          <HeaderCell>Comments</HeaderCell>
          <Cell dataKey="comments" />
        </Column>

        <Column width={160} fixed="right">
          <HeaderCell>...</HeaderCell>
          <Cell style={{ padding: "6px" }}>
            {(rowData) => (
              <div>
                <Button
                  appearance="link"
                  onClick={() =>
                    navigate(
                      `/vet-treatment/edit/${rowData.id}/${rowData.reference_number}`
                    )
                  }
                >
                  Edit
                </Button>
                <Button
                  appearance="link"
                  onClick={() => {
                    alert(`id:${rowData.idr}`);
                    const result = axiosInstance.post(
                      "/api/delete-vet-treatment",
                      {
                        id: rowData.id,
                      }
                    );
                  }}
                >
                  Delete
                </Button>
              </div>
            )}
          </Cell>
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={data.length}
          limitOptions={[20, 40, 80, 160, 300]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}

export default VetTable;
